<template>
    <div class="vc-panel vcd">
        <!-- <img style="width: 100px;" src="@/assets/images/app_logo256.png" alt="应用Logo" /> -->
   
        <div class="loginbrd">
            <div class="inrect">
                <div class="color1" data-v-6fd59704="" style="font-size: 30px;font-weight: bold;margin-bottom: 30px;">找回密码</div>
                <div>
                    <div class="slab">邮箱地址</div>
                    <div class="minput-dv mgt10">
                        <SvgIcon fill="var(--ek-text-color2)" svgname="ic_account" class="sic"></SvgIcon>
                        <input type="text" v-model="account" placeholder="请输入邮箱地址" class="minput" style="flex-grow: 1;width: 0px;" />
                    </div>
                </div>
                <div class="v-flex mgt10">
                    <IconMenu @click="sendCode" svgname="ic_sendemail" :name="isSend?'已发送':'发送验证码'"></IconMenu>
                </div>
                <div style="margin-top: 40px;">
                
                    <div class="minput-dv mgt10">
                        <SvgIcon fill="var(--ek-text-color2)" svgname="ic_veryCode" class="sic"></SvgIcon>
                        <input type="text" v-model="password" placeholder="请输入验证码" class="minput" style="flex-grow: 1;width: 0px;" />
                    </div>
                </div>
                <div style="margin-top: 30px;">
                
                    <div class="minput-dv mgt10">
                        <SvgIcon fill="var(--ek-text-color2)" svgname="ic_password" class="sic"></SvgIcon>
                        <input type="password" v-model="password" placeholder="输入新密码" class="minput" style="flex-grow: 1;width: 0px;" />
                    </div>
                </div>
              
                <div @click="login" class="bnt-login focus-s">修改密码</div>

                <div @click="goback" class="mlink bnt-reg focus-s">返回登录</div>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';
import IconMenu from '@/components/IconMenu.vue';
import httpClient from '@/commom/http/httpClient.js';
export default {
    name: 'FindPasswordPage',
    components: {
        SvgIcon,
        IconMenu
    },
    data(){
        return {
            isSend:false,
            account:"",
            veryCode:"",
            password:"",
        }
    },
    methods:{
        ///发送验证码
        sendCode:function(){
            var account = this.account.trim()
            if(account.length==0){
                this.$message.error("请输入邮箱地址")
                return
            }
            var req = {
                account:account,
            }
            var that = this
            httpClient.invoke("UserAPI.SendFindPassVeryCode",req,function(res){
                if(res.code == 0){
                    that.isSend = true
                    that.$message.success("发送成功")
                    return
                }
                that.$message.error(res.msg)
            })
        },
        ///更新密码
        updatePassword:function(){
            if(this.isSend==false){
                this.$message.error("请先发送邮件验证码")
                return
            }
            var account = this.account.trim()
            var veryCode = this.veryCode.trim()
            var password = this.password.trim()

            if(account.length == 0){
                this.$message.error("请输入邮箱地址")
                return
            }
            if(veryCode.length == 0){
                this.$message.error("请输入验证码")
                return
            }
            if(password.length == 0){
                this.$message.error("请输入登录密码")
                return
            }
            var req = {
                account:account,
                veryCode:veryCode,
                password:password,
            }
            var that = this
            httpClient.invoke("UserAPI.UpdatePassword",req,function(res){
                if(res.code == 0){
                    that.$message.success("修改成功")
                    that.$router.replace("/main-page")
                    return
                }
                this.$message.error(res.msg)
            })
        },
        ///返回登录
        goback:function(){
            this.$router.go(-1)
        }
        
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.bnt-reg{
    margin-top: 30px;
    text-align: center;
}
.bnt-login{
    margin-top: 40px;
    background: var(--ek-color-primary);
    color: white;
    text-align: center;
    line-height: 40px;
    border-radius: 5px;
}
.stitle{
    font-size: 30px;
    font-weight: bold;
    font-family: sans-serif;
    margin-top: 20px;
}
.slab{
    color: var(--ek-text-color2);
}
.minput{
    height: 40px;
    color: var(--ek-text-color1);
}
.inrect{
    margin-left: 70px;
    margin-right: 70px;
    margin-top: 30px;
}
.sic{
    margin-left: 15px;
    margin-right: 7px;
}
.minput-dv {
    background: var(--ek-input-backColor);
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: 5px;
}

.vcd {
    justify-content: center;
    align-items: center;
}

.loginbrd {
    width: 500px;
    max-width: 90vw;
    height: 500px;
    max-height: 90vh;
    background: var(--ek-mainbody-bgcolor);
    border-radius: 15px;
    box-shadow: 5px 5px 5px #00000005;
   
    padding-bottom: 40px;
}

/* 针对不同屏幕尺寸的响应式调整 */
@media (max-width: 768px) {
    .loginbrd {
        width: 90%;
        /* 平板设备上使用90%宽度 */
        height: auto;
        /* 高度自适应 */
        min-height: 500px;
        /* 设置最小高度 */
    }
    
    .inrect {
        margin-left: 40px;
        margin-right: 40px;
        /* 平板设备上减小左右边距 */
    }
}

@media (max-width: 480px) {
    .loginbrd {
        width: 95%;
        /* 手机设备上使用95%宽度 */
        height: auto;
        /* 高度自适应 */
        min-height: 450px;
        /* 设置最小高度 */
        border-radius: 10px;
        /* 小屏幕上减小圆角 */
    }
    
    .inrect {
        margin-left: 20px;
        margin-right: 20px;
        /* 手机设备上进一步减小左右边距 */
        margin-top: 30px;
        /* 手机设备上略微减小上边距 */
    }
}
</style>
